import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { lazyGetAttachment, lazyRefreshThumbnailImageUrl } from 'owa-attachment-model-store';
import { ImageGalleryItem } from 'owa-sxsdata';
import { trace } from 'owa-trace';

// Note: this function is for list view
export default async function createImageGalleryFromAttachmentViewStateIds(
    attachmentViewStateIds: string[],
    getAttachmentFullViewStateFromId: (id: string) => AttachmentFullViewState
): Promise<ImageGalleryItem[]> {
    const imageGallery: ImageGalleryItem[] = [];
    const getAttachment = await lazyGetAttachment.import();
    const refreshThumbnailImageUrl = await lazyRefreshThumbnailImageUrl.import();

    for (let i = 0; i < attachmentViewStateIds.length; i++) {
        const attachmentViewState = getAttachmentFullViewStateFromId(attachmentViewStateIds[i]);

        try {
            await refreshThumbnailImageUrl(attachmentViewState.attachmentId, true);
        } catch (error) {
            trace.warn(
                `Unable to refresh thumbnail image for ${attachmentViewState.attachmentId}. Got error ${error}`
            );
        }

        const attachmentModel = getAttachment(attachmentViewState.attachmentId);
        const imageGalleryItem: ImageGalleryItem = {
            downloadUrl: attachmentModel.download.url,
            id: attachmentViewState.attachmentId,
            previewUrl: attachmentModel.previewImage.url,
            thumbnailUrl: attachmentModel.thumbnailImage.url,
        };
        imageGallery.push(imageGalleryItem);
    }

    return imageGallery;
}
